var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{attrs:{"options":_vm.allEquipments,"multiple":true,"track-by":"id","label":"internalName","placeholder":"Ausstattungen auswählen","close-on-select":true},on:{"input":_vm.onInput},model:{value:(_vm.internalSelection),callback:function ($$v) {_vm.internalSelection=$$v},expression:"internalSelection"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }